import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import tippy from 'tippy.js'

class CalculatorInput extends React.Component {
  state = { glow: false }

  componentDidMount = _ => tippy(this.refs.infoIcon, { duration: 0, theme: 'topbar', placement: 'bottom' })

  componentWillUnmount = _ => this.timeout && clearTimeout(this.timeout)

  componentWillReceiveProps(nextProps) {
    if ((nextProps.rawValue) !== (this.props.rawValue)) {
      this.setState({ glow: true })
      clearTimeout(this.timeout)
      this.timeout = setTimeout(
        _ => this.setState({ glow: false }),
        1600
      )
    }
  }

  glowClass = _ => {
    if (this.props.bottomRowToggle) return this.state.glow ? this.props.classes.shortWidthInputGlow : this.props.classes.shortWidthInput
    return this.state.glow && this.props.classes.inputGlow
  }

  render() {
    const { state: { glow }, props: { label, titleTag, value, fnKey, callback, currentCamera, unit, labelClass, classes, bottomRowToggle, uiAction, rawValue } } = this

    return (
      <div className={classes.container}>
        <div title={label === "Distance" ? '' : (titleTag || label)} className={classes[labelClass] || classes.normalLabel}>
          { label }
          { label === "Distance" &&
            <a className={classes.infoTooltip} title='Distance is the ground space between camera and scene height' ref='infoIcon'>
              <FontAwesomeIcon icon='info-circle' />
            </a>
          }
        </div>
        <div className={classes.inputWrapper} >
          <span className={bottomRowToggle ? classes.shortWidthSuffix : classes.suffix}>{unit}</span>
          <input
            value={value}
            type='tel'
            onChange={({ target: { value } }) => callback(value, fnKey, currentCamera.id)}
            onKeyPress={e => e.key === 'Enter' && e.target.blur()}
            className={this.glowClass()}
          />
          { bottomRowToggle &&
            <a
              onClick={uiAction}
              className={classes.bottomRowButton}
              title='Show Imager Size and Focal Length'
            >
              <FontAwesomeIcon icon='cog' />
            </a>
          }
        </div>
      </div>
    )
  }
}

export default injectSheet(style)(CalculatorInput)



// WEBPACK FOOTER //
// ./src/components/CalculatorInput/index.js